export default {
  path: '/tokens',
  name: 'tokens',
  component: () => import(/* webpackChunkName: "tokens" */ './_views/UmsTokens'),
  meta: {
    title: 'Tokens',
    navigation: {
      position: 5,
      name: 'Tokens',
      icon: 'vpn_key',
      to: {
        name: 'tokens',
        query: {
          pageNum: '1',
        },
      },
    },
  },
};
